import { createContext, useContext } from 'react'

interface LessonContextProps {
  next(): void
  submit: boolean
  setSubmit(submit: boolean): void
}

export const LessonContext = createContext<LessonContextProps>(
  Object.create(null)
)

export const LessonContextConsumer = LessonContext.Consumer

export const useLesson = () => useContext(LessonContext)

interface LessonProviderProps {
  next(): void,
  submit: boolean,
  setSubmit(submit: boolean): void
}

export const LessonProvider: React.FC<LessonProviderProps> = ({
  children,
  next,
  submit,
  setSubmit
}) => {
  
  return (
    <LessonContext.Provider value={{ next, submit, setSubmit }}>
      {children}
    </LessonContext.Provider>
  )
}
